import { useEffect, useState } from "react";
import { Send } from "lucide-react";

const input = "mt-1 w-full rounded-md border border-linen bg-ivory px-3 py-2 text-sm outline-none focus:border-forest";
const label = "text-xs font-semibold uppercase tracking-[0.15em] text-moss";
const btn = "flex items-center gap-2 rounded-md bg-forest px-4 py-2 text-sm font-semibold text-ivory transition-colors hover:bg-forest-dark disabled:opacity-50";

export function PatientFormsCard({ data, email, api, run }) {
  const [forms, setForms] = useState([]);
  const [formType, setFormType] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/forms").then((r) => { setForms(r.data); if (r.data[0]) setFormType(r.data[0].form_type); }); }, [api]);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    await run(() => api.post(`/admin/patients/${encodeURIComponent(email)}/send-form`, { form_type: formType, message }).then(() => setMessage("")), "Form emailed to patient");
    setBusy(false);
  };

  const signed = new Set(data.forms.map((f) => f.form_type));

  return (
    <section data-testid="patient-send-form" className="rounded-lg border border-linen bg-ivory p-5">
      <h3 className="font-serif text-xl font-medium text-forest">Send a legal document</h3>
      <p className="mt-1 text-xs text-moss">Emails the patient a secure link to sign online. Signed copies appear under Visits &amp; signed forms.</p>
      <form onSubmit={send} className="mt-4 space-y-3">
        <div><label className={label}>Document</label>
          <select data-testid="send-form-select" value={formType} onChange={(e) => setFormType(e.target.value)} className={input}>
            {forms.map((f) => <option key={f.form_type} value={f.form_type}>{f.title}{signed.has(f.form_type) ? " (signed before)" : ""}</option>)}
          </select>
        </div>
        <div><label className={label}>Personal message (optional)</label><textarea data-testid="send-form-message" rows={2} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Please sign before your filler appointment on Friday." className={input} /></div>
        <button type="submit" data-testid="send-form-button" disabled={busy || !formType} className={btn}><Send size={14} /> {busy ? "Sending..." : "Email Document"}</button>
      </form>
      <ul className="mt-5 divide-y divide-linen text-sm">
        {data.forms_sent.map((f, i) => (
          <li key={`${f.sent_at}-${i}`} className="flex items-center justify-between gap-3 py-2">
            <span className="text-forest">{f.form_name}</span>
            <span className="text-xs text-moss">sent {f.sent_at.slice(0, 10)}{f.type === "auto_form" ? " · auto" : ""}{f.status === "mocked" ? " · not delivered" : ""}</span>
          </li>
        ))}
        {data.forms_sent.length === 0 && <li className="py-2 text-xs text-moss">No documents sent yet.</li>}
      </ul>
    </section>
  );
}
